App.namespace.wrap('views.shared.fixTooltips', (options) => {

  const POSITION_ATTRIBUTE = 'data-microtip-position';
  const ORG_POSITION_ATTRIBUTE = 'data-microtip-org-position'


  const fixPositions = () => {
    console.time('tooltips-position');
    // data-microtip-position="right" indicates that tooltip will be on left from the handler for some strange reason
    let container = options?.container;
    if (!container) {
      container = document;
    }
    const tooltips = container.querySelectorAll('[aria-label][role="tooltip"]');

    Array.from(tooltips).forEach(element => {
      let positionValue = element.getAttribute(POSITION_ATTRIBUTE);
      let orgPositionValue = element.getAttribute(ORG_POSITION_ATTRIBUTE);

      if (options?.repaint) {
        // revert back to original position
        if (orgPositionValue && orgPositionValue.length > 0) {
          element.setAttribute(POSITION_ATTRIBUTE, orgPositionValue);
        } else {
          element.removeAttribute(POSITION_ATTRIBUTE);
        }
      } else {
        element.setAttribute(ORG_POSITION_ATTRIBUTE, positionValue ?? '');
      }

      const tooltipWidth = 150 + 16;
      const { right, left, width } = element.getBoundingClientRect();

      if (right + width / 2 < tooltipWidth / 2) {
        element.setAttribute(POSITION_ATTRIBUTE, 'right');
      }
      if (left + width / 2 < tooltipWidth / 2) {
        element.setAttribute(POSITION_ATTRIBUTE, 'left');
      }
    });
    console?.timeEnd('tooltips-position');
  }

  document.addEventListener("DOMContentLoaded", function() {
    setTimeout(fixPositions, 1000);
  });

  if (options?.force) {
    fixPositions();
  } else if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(fixPositions, 1000);
  }
});

// On touch devices a tap leaves the tooltip stuck in its :hover/:focus state, so
// it stays visible (or reappears) while the page scrolls. We mark <html> while
// scrolling so CSS force-hides the legacy tooltips, and keep that mark until the
// next deliberate tap (a touch that ends without moving) re-enables them — a
// scroll on its own never shows them again. Registered once at module load (not
// inside the fixTooltips callback, which runs on every invocation).
(() => {
  // Scoped to legacy tooltips (the CSS-driven ::after); DS tooltips
  // (.ds-tooltip / .ds-tooltip__content) manage their own visibility and focus.
  const LEGACY_TOOLTIP_SELECTOR = '[aria-label][role~="tooltip"]:not(.ds-tooltip)';
  const SUPPRESSED_CLASS = 'js-tooltips-suppressed';
  const isTouchDevice = typeof window.matchMedia === 'function'
    && window.matchMedia('(hover: none), (pointer: coarse)').matches;
  if (!isTouchDevice) {
    return;
  }

  const root = document.documentElement;
  let touchMoved = false;

  const suppressTooltips = () => {
    root.classList.add(SUPPRESSED_CLASS);
    const active = document.activeElement;
    if (active && typeof active.matches === 'function' && active.matches(LEGACY_TOOLTIP_SELECTOR)) {
      active.blur();
    }
  };

  window.addEventListener('touchstart', () => {
    touchMoved = false;
  }, { passive: true, capture: true });

  window.addEventListener('touchmove', () => {
    touchMoved = true;
    suppressTooltips();
  }, { passive: true, capture: true });

  window.addEventListener('touchend', () => {
    if (!touchMoved) {
      root.classList.remove(SUPPRESSED_CLASS);
    }
  }, { passive: true, capture: true });

  window.addEventListener('scroll', suppressTooltips, { passive: true, capture: true });
})();
